import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import Presentation from "@/Presentation";
import AdminDashboard from "@/AdminDashboard";
import ErrorBoundary from "@/components/ErrorBoundary";

const path = window.location.pathname.replace(/\/+$/, "");

let Root = App;
if (path === "/presentation") Root = Presentation;
if (path === "/admin") Root = AdminDashboard;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </React.StrictMode>,
);
